export enum AppResponseMessage {
  INVALID_TOKEN = 'invalid_token'
}
